export default __webpack_public_path__ + "static/media/thumb.b868344b.svg";